import type { FC, ReactNode } from 'react';
import useI18n from '@i18n';

interface IBaseEmptyProps {
    id?: string;
    message?: ReactNode | string;
}

const BaseEmpty: FC<IBaseEmptyProps> = ({ id, message }) => {
    const { t } = useI18n();
    return (
        <p id={`${id}EmptyMessage`} className="epn-search-error">
            {message || t('Nothing found')}
        </p>
    );
};

export default BaseEmpty;
